module.exports = __webpack_public_path__ + "static/img/white.e2f9b11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yeti_page/white.jpg
// module id = N1S0
// module chunks = 1